<template>
    <div>
        <div v-if="data && data.product && Object.keys(data.product).length">
            <div class="top-page top-page_empty">
                <div class="top-page__container">
                    <div class="top-page__breadcrumbs breadcrumbs">
                        <ul class="breadcrumbs__list">
                            <li class="breadcrumbs__item">
                                <NuxtLink to="/" class="breadcrumbs__link">Le'Perle</NuxtLink>
                            </li>
                            <li class="breadcrumbs__item" v-if="data.product?.category">
                                <NuxtLink :to="{ name: 'catalog-categoryId', params: { categoryId: data.product.category.slug } }" class="breadcrumbs__link">{{ data.product.category.title }}</NuxtLink>
                            </li>
                            <li class="breadcrumbs__item">
                                <span class="breadcrumbs__current">{{ data.product?.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <section class="product">
                <div class="product__container">
                    <div class="product__body">
                        <div class="product__images">
                            <swiper
                                :slides-per-view="1"
                                :modules="[Thumbs, Navigation, Pagination]"
                                :speed="800"
                                :thumbs="{ swiper: thumbsSwiper }"
                                :pagination="{ el: '.main-slider__pagination', clickable: true }"
                                :navigation="{
                                    prevEl: '.main-slider__navigation .btn-prev',
                                    nextEl: '.main-slider__navigation .btn-next',
                                }"
                                class="product__main-slider main-slider"
                                v-if="data.product?.downloads || data.product?.sets">
                                <div class="product__main-label" v-if="data.product?.old_price">{{ Math.round(((data.product.old_price - data.product.price) / data.product.old_price) * 100) }}%</div>

                                <swiper-slide v-for="media in data.product?.downloads" :key="media.id" class="main-slider__slide-ibg">
                                    <a data-fancybox="gallery" :href="getImageProduct(media.path)" class="fancybox-link">
                                        <NuxtImg :src="getImageProduct(media.path)" alt="" />
                                    </a>
                                </swiper-slide>
                                <swiper-slide v-for="media in data.product?.sets" :key="media.id" class="main-slider__slide-ibg">
                                    <a data-fancybox="gallery" :href="getImageProduct(media.path)" class="fancybox-link">
                                        <NuxtImg :src="getImageProduct(media.path)" alt="" />
                                    </a>
                                </swiper-slide>

                                <swiper-slide class="main-slider__slide-ibg">
                                    <a data-fancybox="gallery" href="/img/product/im1.webp" class="fancybox-link">
                                        <NuxtImg src="/img/product/im1.webp" alt="" />
                                    </a>
                                </swiper-slide>
                                <swiper-slide class="main-slider__slide-ibg">
                                    <a data-fancybox="gallery" href="/img/product/im2.webp" class="fancybox-link">
                                        <NuxtImg src="/img/product/im2.webp" alt="" />
                                    </a>
                                </swiper-slide>

                                <div class="main-slider__navigation navigation-product">
                                    <button class="navigation-product__btn btn-prev"></button>
                                    <button class="navigation-product__btn btn-next"></button>
                                </div>
                                <div class="main-slider__pagination pagination"></div>
                            </swiper>
                            <swiper :slides-per-view="4" :space-between="6" :modules="[Thumbs, Navigation, Pagination]" watch-slides-progress @swiper="setThumbsSwiper" class="product__trumb-slider trumb-slider" v-if="data.product?.downloads || data.product?.sets">
                                <swiper-slide v-for="media in data.product?.downloads" :key="media.id" class="trumb-slider__slide-ibg">
                                    <NuxtImg :src="getImageProduct(media.path)" alt="" />
                                </swiper-slide>
                                <swiper-slide v-for="media in data.product?.sets" :key="media.id" class="trumb-slider__slide-ibg">
                                    <NuxtImg :src="getImageProduct(media.path)" alt="" />
                                </swiper-slide>
                                <swiper-slide class="trumb-slider__slide-ibg">
                                    <NuxtImg src="/img/product/im1.webp" alt="" />
                                </swiper-slide>
                                <swiper-slide class="trumb-slider__slide-ibg">
                                    <NuxtImg src="/img/product/im2.webp" alt="" />
                                </swiper-slide>
                            </swiper>
                            <div class="product__reviews pc">
                                <div class="product__reviews-title">Відгуки</div>
                                <ReviewsProduct :data="reviews" @toggle-popup="toggleReviewPopup" :is-open="isMenuAddReview" />
                            </div>
                        </div>

                        <div class="product__content content-product">
                            <div class="content-product__body">
                                <span class="content-product__is-aviables" style="background: #a8df5c" v-if="data.product?.in_stock === 1">В наявності!</span>
                                <span class="content-product__is-aviables" style="background: #fdb642" v-if="data.product?.in_stock === 2">Закінчується!</span>
                                <span class="content-product__is-aviables" style="background: #c5c5c5" v-if="data.product?.in_stock === 0">Немає у наявності!</span>
                                <br v-if="data.product?.available_for_order === 1" />
                                <h1 class="content-product__title" v-if="data.product">{{ data.product.name }}</h1>
                                <div class="content-product__material">
                                    <template v-if="data.product?._material">
                                        {{ data.product._material }}
                                    </template>
                                    <template v-else>
                                        <span v-for="(material, index) in data.product?.material" :key="index">
                                            {{ material.value }}
                                            <span v-if="index < (data.product?.material?.length || 0) - 1">,</span>
                                        </span>
                                    </template>
                                </div>
                                <div class="content-product__price">
                                    <div class="content-product__price-price price">
                                        <div class="price__current sale">{{ Math.round(variantPrice) }} грн.</div>
                                        <div class="price__old" v-if="data.product?.old_price && data.product.old_price !== null">
                                            {{ Math.round(variantOldPrice) }}
                                            <span v-if="variantOldPrice !== null">грн.</span>
                                        </div>
                                    </div>

                                    <div class="content-product__price-profit" v-if="data.product?.old_price && data.product.old_price !== null">
                                        <span>Вигода {{ Math.round(variantOldPrice) - Math.round(variantPrice) }} грн.</span>
                                    </div>
                                </div>

                                <div v-if="data.product?.engraving" class="content-product__engraving">
                                    <div class="content-product__engraving-select">
                                        <v-select v-model="selectedEngraving" :options="data.product.engraving" class="form form-v-select" size="10" label="Engraving" placeholder="Оберіть фразу">
                                            <template #no-options>
                                                <div class="no-options">Немає доступних фраз</div>
                                            </template>
                                        </v-select>
                                    </div>

                                    <transition name="accordion" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
                                        <div class="content-product__engraving-input" v-if="isVisibleEngraving">
                                            <input v-model="inputEngraving" class="input" type="text" placeholder="Власна назва" />
                                        </div>
                                    </transition>

                                    <div class="content-product__engraving-btn">
                                        <button v-if="isVisibleEngraving" @click="toggleShowEngraving" class="content-product__engraving-button button button_line">
                                            <span>-</span>
                                            Прибрати власний надпис
                                        </button>
                                        <button v-if="!isVisibleEngraving" @click="toggleShowEngraving" class="content-product__engraving-button button button_line">
                                            <span>+</span>
                                            Додати свій надпис
                                        </button>
                                    </div>
                                </div>
                                <div v-for="set in data.product.sets" :key="set.id">
                                    <VariantsComponent :title="set.name" :product_id="set.id" :variant_id="set.id" :variants="set.variants" @selectedVariants="handleSelectedVariant" class="sizes_small content-product__sizes" />
                                </div>

                                <Sizes v-if="!data.product.is_set" class="sizes_small content-product__sizes" :title="sizeLabel" :sizes="getAvailableSizes()" :selectedSize="selectedSize" @selected="selectedSize = $event" />
                                <Lenght
                                    v-if="!data.product.is_set"
                                    class="sizes_small content-product__sizes"
                                    :title="'Довжина (см):'"
                                    :lengths="getAvailableLengths()"
                                    :category_all="data.product.category_all"
                                    :selectedLength="selectedLength"
                                    @selected="selectedLength = $event"
                                    @showPopupSizes="sizesCategory = $event" />

                                <Clasp v-if="!data.product.is_set" class="content-product__clasp" title="Застібка:" :clasp="getAvailableClasps()" :selectedClasp="selectedClasp" @selected="selectedClasp = $event" />
                                <Colors v-if="!data.product.is_set" class="content-product__colors" :title="'Колір: ' + selectedColor" :colors="getAvailableColors()" v-model="selectedColor" @selected="selectedColor = $event" />

                                <div class="content-product__amount amount-product">
                                    <div class="content-product__subtitle">Кількість:</div>

                                    <div class="amount-product__line">
                                        <Qty v-model="quantity" @update:modelValue="(newQuantity) => updateQuantity(newQuantity)" />
                                        <div class="button-fixed-bottom">
                                            <button class="amount-product__button button amount-product__button-main" @click="addToCart">
                                                <span v-if="data.product.available_for_order === 1">Передзамовлення</span>
                                                <span v-else>Додати в кошик</span>
                                            </button>
                                            <button class="flex w-full flex-col items-center justify-center gap-[7px] rounded-[6px] bg-[#000] text-[#fff] lg:hidden" @click="toggleMonoCheckoutPopup">
                                                <span v-if="data.product.available_for_order === 1">Передзамовлення</span>
                                                <span class="text-[14px] text-[#fff]" v-else>Оформити через</span>
                                                <img width="133" height="14" src="/img/monocheckout.svg" alt="" />
                                            </button>
                                        </div>
                                    </div>
                                    <div class="amount-product__line pc">
                                        <div class="button-fixed-bottom">
                                            <button class="amount-product__button button button-monocheckout" @click="toggleMonoCheckoutPopup">
                                                <span v-if="data.product.available_for_order === 1">Передзамовлення</span>
                                                <span v-else>Оформити через</span>
                                                <img width="123" height="14" src="/img/monocheckout.svg" alt="" />
                                            </button>
                                        </div>
                                    </div>
                                    <div class="amount-product__line">
                                        <span v-if="variantVendorCode">код товару: {{ variantVendorCode }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="content-product__description description-product">
                                <div class="content-product__subtitle">Характеристики:</div>

                                <div class="characteristics-product__items" v-for="characteristic in data.product.characteristics" :key="characteristic.filter_name">
                                    <div class="characteristics-product__title">
                                        {{ characteristic.filter_name }}
                                    </div>
                                    <div class="characteristics-product__text">
                                        <span v-for="value in characteristic.values" :key="value">
                                            {{ value }}
                                        </span>
                                    </div>
                                </div>

                                <div class="characteristics-product__pays">
                                    <div class="characteristics-product__pay">
                                        <NuxtImg src="/img/footer/apple-pay.svg" alt="Apple Pay" width="60" />
                                    </div>
                                    <div class="characteristics-product__pay">
                                        <NuxtImg src="/img/footer/google-pay.svg" alt="Google Pay" width="60" />
                                    </div>
                                    <div class="characteristics-product__pay">
                                        <NuxtImg src="/img/footer/mastercard.svg" alt="Mastercard" width="40" />
                                    </div>
                                    <div class="characteristics-product__pay">
                                        <NuxtImg src="/img/footer/visa.svg" alt="Visa" width="40" />
                                    </div>
                                    <div class="characteristics-product__pay">
                                        <NuxtImg src="/img/footer/monopay.webp" alt="MonoPay" width="25" />
                                    </div>
                                    <div class="characteristics-product__pay">
                                        <NuxtImg src="/img/footer/wayforpay.svg" alt="WayForPay" width="65" />
                                    </div>
                                </div>
                            </div>
                            <div class="product__reviews tablet">
                                <div class="product__reviews-title">Відгуки</div>
                                <ReviewsProduct :data="reviews" @toggle-popup="toggleReviewPopup" :is-open="isMenuAddReview" />
                            </div>
                            <div class="content-product__description description-product">
                                <div class="description-product__text" v-if="data.product.description !== 'NULL'"></div>

                                <div>
                                    <div v-for="(item, index) in computedAccordionData" :key="index" class="accordion-item">
                                        <button @click="toggleAccordion(index)">
                                            {{ item.title }}
                                            <span class="_icon-close" :style="isOpen[index] ? 'transform: rotate(0deg);' : ''"></span>
                                        </button>
                                        <transition name="slide-fade">
                                            <div v-if="isOpen[index]" class="accordion-content" v-html="item.content"></div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <ProductsSliderArray :title="'Купляють Разом'" :products="data.product.recommendations" id="1" />
            <ProductsSliderArray :title="'Останні переглянуті товари'" :products="viewedProducts" id="2" />
        </div>
        <div v-else-if="pending">Завантаження...</div>
        <div v-else-if="error">
            <p>Не вдалося завантажити товар. Спробуйте пізніше.</p>
        </div>
        <popup-sizes :show="isPopupSizesOpen" :category="categorySizes" :characteristics="data.product.characteristics" @update:show="isPopupSizesOpen = $event"></popup-sizes>

        <MonoCheckoutPopupComponent :show="isPopupMonoCheckout" @update:show="isPopupMonoCheckout = $event" :product_id="data?.product?.id" :title="data?.product?.name" :price="variantPrice" :old_price="variantOldPrice" :vendor_code="variantVendorCode" :quantity="quantity" />

        <PopupAddReview :product_id="data?.product?.id" :title="data?.product?.name" :is-open="isMenuAddReview" @update:isOpen="toggleReviewPopup" />
    </div>
</template>

<script setup>
import { reactive, ref, onMounted, watch, computed, watchEffect, getCurrentInstance, nextTick } from "vue";
import { ProductsSliderArray, Sizes, Lenght, Clasp, Colors, PopupSizes, PopupAddReview, VariantsComponent, Qty, ReviewsProduct, MonoCheckoutPopupComponent } from "#components";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Thumbs, Navigation, Pagination } from "swiper";
import { useRoute, useRouter, useAsyncData, showError } from "#app";
import { useCartStore } from "@/stores/cart";
import { useGlobalStore } from "@/stores/global";
import { useESputnik } from "~/composables/useESputnik";
import vSelect from "vue-select";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "vue-select/dist/vue-select.css";

const route = useRoute();
const router = useRouter();
const cartStore = useCartStore();
const globalStore = useGlobalStore();
const { init: initESputnik, trackProductPage } = useESputnik();
const config = useRuntimeConfig();
const nuxtApp = useNuxtApp();
const { $fbq } = useNuxtApp();
const { proxy } = useScriptGoogleTagManager();

const apiUrl = config.public.apiUrl;
const uploadUrl = config.public.imageUrl;

const slug = ref(route.params.slug);
const vendorCodeParam = ref(route.params.vendor_code);

const { data, pending, error, refresh } = await useAsyncData(
    `product-${slug.value}`,
    async () => {
        try {
            const response = await $fetch(`${apiUrl}products/${slug.value}`);
            if (!response.data || response.data.is_visible === 0) {
                throw createError({ statusCode: 404, statusMessage: "Product not found or not visible", fatal: true });
            }
            return { product: response.data };
        } catch (err) {
            console.error("Failed to fetch product:", err);
            if (err.response && err.response.status === 404) {
                throw createError({ statusCode: 404, statusMessage: "Product not found", fatal: true });
            }
            throw createError({ statusCode: 500, statusMessage: "Failed to load product data", fatal: true });
        }
    },
    {
        watch: [slug],
    },
);

if (error.value) {
    showError({ statusCode: 404, message: "Product not found" });
}

const selectedEngraving = ref(null);
const inputEngraving = ref(null);
const thumbsSwiper = ref(null);
const priceStack = reactive({});
const selectedVariants = ref(null);
const selectedVariantsArray = ref([]);
const categorySizes = ref(0);
const isPopupSizesOpen = ref(false);
const isPopupMonoCheckout = ref(false);
const sizesCategory = ref(null);
const selectedSize = ref(null);
const selectedLength = ref(null);
const selectedClasp = ref(null);
const selectedColor = ref(null);
const selectedVariant = ref(null);
const variantPrice = ref(0);
const variantOldPrice = ref(0);
const variantVendorCode = ref(null);
const quantity = ref(1);
const sizeLabel = ref("");
const isOpen = ref([]);
const reviews = ref([]);
const isMenuAddReview = ref(false);
const isVisibleEngraving = ref(null);
const viewedProducts = ref([]);

const totalPrice = computed(() => cartStore.totalPriceCart);

const computedAccordionData = computed(() => {
    if (!data.value?.product) return [];

    let items = [
        { title: "Чи тьмяніють прикраси?", content: '<div class="description-product__text">При правильній експулатації прикраси не тьмяніють, але якщо така ситуація сталась за 14 днів експлуатації то ми зробимо вам обмін товару за наш рахунок:)</div>' },
        { title: "Чи можна мочити прикраси?", content: '<div class="description-product__text">Можна мочити: прикраси з перлин, або іншого каміння на срібній застібці.<br><br>Не рекомендується мочити прикраси з срібним покриттям та позолотою так як це може вплинути на їх зовнішній вигляд.</div>' },
        {
            title: "Доставка та оплата",
            content:
                '<div class="description-product__text"><div class="description-product__line"><div class="description-product__img"><img src="/assets/img/novaposhta.png" alt="" /></div><div class="description-product__line-body"><span>Нова пошта відділення або кур\'єр</span><span>від 70 грн</span></div></div><div class="description-product__line"><div class="description-product__img"><img src="/assets/img/ukrposhta.png" alt="" /></div><div class="description-product__line-body"><span>Укр Пошта відділення </span><span style="text-align: end">в Україні від 40 грн<br />в Європу від 250 грн</span></div></div></div> <div class="description-product__text"><p>Накладний платіж з передплатою 150 грн. (додатково оплачується комісія за повернення коштів в розмірі 20 грн і 2% від суми замовлення)</p><p>Оплата за реквізитами ФОП - комісія 0%</p><p>Через платіжну систему MonoPay - комісія 0%</p></div>',
        },
        { title: "Умови Безкоштовної доставки", content: '<div class="description-product__text">Замовлення при повній оплаті від 3000 грн, відправляються безкоштовно по Україні у відділення Нової пошти або УкрПошти.' },
        {
            title: "Яка гарантія на вироби?",
            content:
                '<div class="description-product__text">На всі прикраси, представлені в інтернет-магазині Le-perle, діє гарантія 1 місяць. <br><br>Якщо при першій же примірці з прикрасою щось сталося, ми забезпечуємо обмін виробів, оплачуючи доставку в обидві сторони. У будь-якому іншому випадку наш майстер повинен оцінити виріб для того, щоб визначити, чи потрапляє поломка під гарантію компанії. <br><br>Якщо прикрасу було пошкоджено через неакуратну носку , ми можемо відремонтувати її якщо це можливо, проте доставка в обидві сторони оплачується клієнтом.</div>',
        },
        {
            title: "Чи можу я обміняти товар?",
            content: '<div class="description-product__text">Протягом 14 днів з моменту покупки Ви маєте можливість здійснити обмін обраного товару на інший. <br><br>Обмін можливий лише в тому випадку, якщо збережено товарний вид прикраси, є упаковка, а також немає слідів експлуатації.</div>',
        },
        {
            title: "Коли відправлять моє замовлення?",
            content:
                '<div class="description-product__text">Замовлення надсилаються протягом 1-3 днів з моменту підтвердження замовлення.<br><br>Якщо вам необхідна термінова відправка, звʼяжіться з менеджером в чаті на сайті або в Telegram, Viber за номером телефону, також ви можете залишити коментар при оформленні замовлення.</div>',
        },
    ];

    const description = data.value?.product?.description ?? "";
    if (description.trim() !== "" && description.trim().toUpperCase() !== "NULL") {
        items.unshift({
            title: "Опис товару",
            content: '<div class="description-product__text">' + description + "</div>",
        });
    }

    return items;
});

const getImageProduct = globalStore.getImageProduct;

const getCookie = (name) => {
    if (process.server) return null;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
};

const getEventId = () => {
    if (process.server) return null;
    return `evt_${Math.random().toString(36).substring(2, 15)}`;
};

const getExternalId = () => {
    if (process.server) return null;
    let id = localStorage.getItem("external_id");
    if (!id) {
        id = `id_${Math.random().toString(36).substring(2, 9)}`;
        localStorage.setItem("external_id", id);
    }
    return id;
};

const getOptionValue = (variant, optionName) => {
    const option = variant.option_values.find((opt) => opt.option.name === optionName);
    return option ? option.value : null;
};

const hasOption = (optionName) => {
    return (
        data.value?.product?.variants?.some((variant) => {
            return variant.option_values.find((option) => option.option.name === optionName);
        }) ?? false
    );
};

const getAvailableSizes = () => {
    if (!data.value?.product?.variants) return [];
    return data.value.product.variants.reduce((sizes, variant) => {
        const size = variant.option_values.find((option) => option.option.name === "size");
        if (size) {
            sizeLabel.value = size.option.label || "Розмір:";
        }
        if (size && !sizes.includes(size.value)) {
            sizes.push(size.value);
        }
        return sizes;
    }, []);
};

const getAvailableColors = () => {
    if (!data.value?.product?.variants) return [];
    return data.value.product.variants.reduce((colors, variant) => {
        const color = variant.option_values.find((option) => option.option.name === "color");
        if (color && !colors.some((c) => c.color === color.value) && color.value != "-") {
            colors.push({ color: color.value, color_hex: color.color_hex });
        }
        return colors;
    }, []);
};

const getAvailableLengths = () => {
    if (!data.value?.product?.variants || !hasOption("size")) return [];
    return data.value.product.variants.reduce((lengths, variant) => {
        const size = variant.option_values.find((option) => option.option.name === "size");
        const length = variant.option_values.find((option) => option.option.name === "length");
        if (size && size.value === selectedSize.value && length && !lengths.includes(length.value) && length.value != "-") {
            lengths.push(length.value);
        }
        return lengths;
    }, []);
};

const getAvailableClasps = () => {
    if (!data.value?.product?.variants) return [];
    if (hasOption("size") && !selectedSize.value) return [];
    if (hasOption("length") && !selectedLength.value) return [];

    return data.value.product.variants.reduce((clasps, variant) => {
        const size = variant.option_values.find((option) => option.option.name === "size");
        const length = variant.option_values.find((option) => option.option.name === "length");
        const clasp = variant.option_values.find((option) => option.option.name === "clasp");

        if ((!hasOption("size") || (size && size.value === selectedSize.value)) && (!hasOption("length") || (length && length.value === selectedLength.value)) && clasp && !clasps.includes(clasp.value) && clasp.value != "-") {
            clasps.push(clasp.value);
        }
        return clasps;
    }, []);
};

const selectFirstAvailableOptions = () => {
    if (!data.value?.product?.variants) return;

    const availableSizes = getAvailableSizes();
    if (availableSizes.length > 0 && !selectedSize.value) {
        selectedSize.value = availableSizes[0];
    }
};

const selectVariantByVendorCode = (vendorCode) => {
    if (!data.value?.product?.variants || !vendorCode) return;

    const variant = data.value.product.variants.find((v) => v.vendor_code === vendorCode);
    if (variant) {
        selectedSize.value = getOptionValue(variant, "size");
        selectedLength.value = getOptionValue(variant, "length");
        selectedClasp.value = getOptionValue(variant, "clasp");
        selectedColor.value = getOptionValue(variant, "color");

        selectedVariant.value = variant;
    } else {
        selectFirstAvailableOptions();
    }
};

const toggleReviewPopup = () => {
    isMenuAddReview.value = !isMenuAddReview.value;
};

const setThumbsSwiper = (swiper) => {
    thumbsSwiper.value = swiper;
};

const updateQuantity = (newQuantity) => {
    quantity.value = newQuantity;
};

const toggleAccordion = (index) => {
    if (isOpen.value.length <= index) {
        isOpen.value = [...isOpen.value, ...Array(index + 1 - isOpen.value.length).fill(false)];
    }
    isOpen.value[index] = !isOpen.value[index];
};

const variantMatches = (variant) => {
    if (!variant) return false;
    const sizeMatch = !selectedSize.value || getOptionValue(variant, "size") === selectedSize.value;
    const lengthMatch = !selectedLength.value || getOptionValue(variant, "length") === selectedLength.value;
    const claspMatch = !selectedClasp.value || getOptionValue(variant, "clasp") === selectedClasp.value;
    const colorMatch = !selectedColor.value || getOptionValue(variant, "color") === selectedColor.value;
    return sizeMatch && lengthMatch && claspMatch && colorMatch;
};

const updatePriceStack = (variantData) => {
    if (!data.value?.product?.sets) return;

    const priceStackCount = data.value.product.sets.length;

    let newPrice = variantData.price_origin;
    if (priceStackCount == 1) {
        newPrice = variantData.price_origin * 0.93;
    } else if (priceStackCount >= 2) {
        newPrice = variantData.price_origin * 0.88;
    } else {
        // newPrice = variantData.price_origin * 1.0;
    }

    // else if (priceStackCount >= 3) percentDiscount = 0.15;

    priceStack[variantData.product_id] = {
        price: newPrice,
        old_price: variantData.old_price,
        variant_id: variantData.variant_id,
        product_id: variantData.product_id,
    };
    recalculateSetPrices();
};

const getTotalPrice = () => {
    return Object.values(priceStack).reduce((total, item) => total + parseFloat(item.price || 0), 0);
};

const getOldTotalPrice = () => {
    return Object.values(priceStack).reduce((total, item) => total + parseFloat(item.old_price || 0), 0);
};

const recalculateSetPrices = () => {
    if (data.value?.product?.is_set === 1) {
        variantPrice.value = getTotalPrice();
        variantOldPrice.value = getOldTotalPrice();
    }
};

const initializeSetPriceStack = () => {
    if (!data.value?.product?.is_set || !data.value.product.sets) return;

    const priceStackCount = data.value.product.sets.length;
    let percentDiscount = 0;
    if (priceStackCount == 1) percentDiscount = 0.93;
    if (priceStackCount >= 2) percentDiscount = 0.88;

    data.value.product.sets.forEach((set) => {
        const initialVariant = set.variants?.[0];
        const basePrice = initialVariant ? initialVariant.price : set.price;
        const baseOldPrice = initialVariant ? initialVariant.old_price : set.old_price;
        const baseVariantId = initialVariant ? initialVariant.id : null;

        let newPrice = basePrice;
        // Сначала делим на 0.9 (т.е. прибавляем ~11.11% к цене), затем отнимаем 15%
        if (percentDiscount) {
            newPrice = (basePrice / 0.93) * percentDiscount;
        }

        priceStack[set.id] = {
            price: newPrice,
            old_price: baseOldPrice,
            variant_id: baseVariantId,
            product_id: set.id,
        };
    });
    recalculateSetPrices();
};

function handleSelectedVariant(event) {
    updatePriceStack(event);
}

const fbProduct = () => {
    if (process.server || !data.value?.product) return;

    const productData = data.value.product;
    const currentVariantPrice = variantPrice.value || productData.price;
    const eventId = getEventId();
    const externalId = getExternalId();

    if ($fbq) {
        $fbq("track", "ViewContent", {
            content_category: productData.category ? productData.category.title : "",
            content_ids: [productData.vendor_code],
            content_name: productData.name,
            content_type: "product",
            value: parseFloat(currentVariantPrice),
            currency: "UAH",
            event_id: eventId,
            external_id: externalId,
        });
    }

    if (nuxtApp.$ttq) {
        nuxtApp.$ttq.track("ViewContent", {
            content_category: productData.category ? productData.category.title : "",
            content_ids: [productData.vendor_code],
            content_name: productData.name,
            content_type: "product",
            value: parseFloat(currentVariantPrice),
            currency: "UAH",
            event_id: eventId,
            external_id: externalId,
        });
    }

    try {
        $fetch(apiUrl + "fbapi", {
            method: "POST",
            body: {
                action: "ViewContent",
                event_id: eventId,
                event_source_url: window.location.href,
                content_category: productData.category ? productData.category.title : "",
                value: parseFloat(currentVariantPrice),
                content_name: productData.name,
                content_ids: [productData.vendor_code],
                currency: "UAH",
                fbc: getCookie("_fbc"),
                fbp: getCookie("_fbp"),
                external_id: externalId,
                client_user_agent: navigator.userAgent,
            },
        }).catch((error) => console.error("FB CAPI ViewContent Error:", error));
    } catch (error) {
        console.error("Error sending FB CAPI ViewContent:", error);
    }
};

const addToCart = (openCart = true) => {
    if (process.server || !data.value?.product) return;

    const productData = data.value.product;
    const isSet = productData.is_set === 1;
    const currentVariant = selectedVariant.value;
    const eventId = getEventId();
    const externalId = getExternalId();

    const variantToAdd = isSet ? null : productData.variants.find(variantMatches);

    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    const comment = inputEngraving.value || selectedEngraving.value?.label || "";

    // Revert to storing the full URL obtained from getImageProduct
    const mediaUrl = (variantToAdd?.downloads?.[0]?.path ? getImageProduct(variantToAdd.downloads[0].path) : null) || (productData.downloads?.[0]?.path ? getImageProduct(productData.downloads[0].path) : "/assets/img/logo.svg");

    const baseItem = {
        product_id: productData.id,
        version_update: 1,
        slug: productData.slug,
        quantity: quantity.value,
        category: productData.category ? productData.category.title : "",
        // Use the full URL again
        media: mediaUrl,
        price: isSet ? getTotalPrice() : variantPrice.value,
        material: productData.material,
        percent: productData.percent ?? 0,
        product: {
            id: productData.id,
            name: productData.name,
            vendor_code: productData.vendor_code,
            price: productData.price,
            old_price: productData.old_price,
            category: productData.category ? productData.category.title : "",
            is_set: productData.is_set,
            in_stock: productData.in_stock,
        },
        ...(comment && { comment: cleanEngraving(comment) }),
    };

    let itemToAdd;
    let cartItemId;

    if (isSet) {
        itemToAdd = {
            ...baseItem,
            id: productData.id,
            is_set: 1,
            parent_id: null,
            sets: priceStack,
            variant: {},
        };
        cartItemId = productData.id;
    } else {
        if (!variantToAdd && productData.variants?.length > 0) {
            console.warn("No matching variant found for selected options.");
            return;
        }
        const variantId = variantToAdd ? variantToAdd.id : productData.id;
        itemToAdd = {
            ...baseItem,
            id: variantId,
            variant_id: variantId,
            vendor_code: variantToAdd ? variantToAdd.vendor_code : productData.vendor_code,
            is_set: 0,
            parent_id: productData.id,
            sets: {},
            variant: variantToAdd || {},
        };
        cartItemId = variantId;
        itemToAdd.selected_options = {
            size: selectedSize.value,
            length: selectedLength.value,
            clasp: selectedClasp.value,
            color: selectedColor.value,
        };
    }

    const existingItemIndex = cart.findIndex((item) => item.id === cartItemId && item.is_set === itemToAdd.is_set && item.engraving === itemToAdd.engraving);

    if (existingItemIndex !== -1) {
        // cart[existingItemIndex].quantity += itemToAdd.quantity;
    } else {
        cart.push(itemToAdd);
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    cartStore.updateCart(cart);

    if (openCart) {
        globalStore.openCart();
    }

    const trackingPrice = parseFloat(itemToAdd.price);
    const trackingVendorCode = isSet ? productData.vendor_code : itemToAdd.vendor_code;
    const trackingVariantCode = isSet
        ? Object.values(itemToAdd.sets)
              .map((s) => s.variant_id || s.product_id)
              .join("/")
        : itemToAdd.vendor_code;

    if ($fbq) {
        $fbq("track", "AddToCart", {
            content_ids: [trackingVendorCode],
            content_type: "product",
            content_name: productData.name,
            value: trackingPrice * itemToAdd.quantity,
            currency: "UAH",
            event_id: eventId,
            external_id: externalId,
        });
    }

    if (nuxtApp.$ttq) {
        nuxtApp.$ttq.track("AddToCart", {
            content_ids: [trackingVendorCode],
            content_type: "product",
            content_name: productData.name,
            value: trackingPrice * itemToAdd.quantity,
            currency: "UAH",
            event_id: eventId,
            external_id: externalId,
        });
    }

    if (process.client && proxy?.dataLayer) {
        proxy.dataLayer.push({ ecommerce: null });
        proxy.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                currency: "UAH",
                value: trackingPrice * itemToAdd.quantity,
                items: [
                    {
                        item_id: trackingVendorCode,
                        item_name: productData.name,
                        item_brand: "Le-perle",
                        item_category: productData.category ? productData.category.title : "",
                        item_variant: trackingVariantCode,
                        price: trackingPrice,
                        quantity: itemToAdd.quantity,
                    },
                ],
            },
        });
    }

    try {
        $fetch(apiUrl + "fbapi", {
            method: "POST",
            body: {
                action: "AddToCart",
                event_id: eventId,
                event_source_url: window.location.href,
                value: trackingPrice * itemToAdd.quantity,
                currency: "UAH",
                content_name: productData.name,
                content_ids: [trackingVendorCode],
                content_type: "product",
                contents: [{ id: trackingVendorCode, quantity: itemToAdd.quantity }],
                fbc: getCookie("_fbc"),
                fbp: getCookie("_fbp"),
                external_id: externalId,
                client_user_agent: navigator.userAgent,
            },
        }).catch((error) => console.error("FB CAPI AddToCart Error:", error));
    } catch (error) {
        console.error("Error sending FB CAPI AddToCart:", error);
    }
};

const toggleShowEngraving = () => {
    isVisibleEngraving.value = isVisibleEngraving.value === 1 ? null : 1;
    if (!isVisibleEngraving.value) {
        inputEngraving.value = "";
    }
};

const toggleMonoCheckoutPopup = () => {
    addToCart(false);
    isPopupMonoCheckout.value = !isPopupMonoCheckout.value;
};

const cleanEngraving = (engraving) => {
    return engraving ? engraving.replace(/\r/g, "") : "";
};

const beforeEnter = (el) => {
    el.style.maxHeight = "0";
};
const enter = (el) => {
    el.style.maxHeight = `${el.scrollHeight}px`;
    el.style.overflow = "hidden";
};
const beforeLeave = (el) => {
    el.style.maxHeight = `${el.scrollHeight}px`;
    el.style.overflow = "hidden";
};
const leave = (el) => {
    el.style.maxHeight = "0";
};

watch(
    () => [selectedSize.value, selectedLength.value, selectedClasp.value, selectedColor.value],
    () => {
        if (data.value?.product && !data.value.product.is_set && data.value.product.variants) {
            selectedVariant.value = data.value.product.variants.find(variantMatches);

            if (selectedVariant.value) {
                variantPrice.value = selectedVariant.value.price;
                variantOldPrice.value = selectedVariant.value.old_price;
                variantVendorCode.value = selectedVariant.value.vendor_code;
            } else {
                variantPrice.value = data.value.product.price;
                variantOldPrice.value = data.value.product.old_price;
                variantVendorCode.value = data.value.product.vendor_code;
            }
        }
    },
    { deep: true },
);

watch(selectedSize, (newSize, oldSize) => {
    if (newSize !== oldSize) {
        const availableLengths = getAvailableLengths();
        if (!availableLengths.includes(selectedLength.value)) {
            selectedLength.value = availableLengths.length > 0 ? availableLengths[0] : null;
        } else if (oldSize === null && availableLengths.length > 0) {
            selectedLength.value = availableLengths[0];
        }
    }
});

watch(selectedLength, (newLength, oldLength) => {
    if (newLength !== oldLength) {
        const availableClasps = getAvailableClasps();
        if (!availableClasps.includes(selectedClasp.value)) {
            selectedClasp.value = availableClasps.length > 0 ? availableClasps[0] : null;
        } else if (oldLength === null && availableClasps.length > 0) {
            selectedClasp.value = availableClasps[0];
        }
    }
});

watch(sizesCategory, () => {
    if (sizesCategory.value.categoryId) {
        isPopupSizesOpen.value = true;
        categorySizes.value = sizesCategory.value.categoryId;
    }
});

watch(
    data,
    (newData) => {
        if (newData?.product) {
            const productData = newData.product;
            // Сначала устанавливаем базовые цены и ревью
            variantPrice.value = productData.price;
            variantOldPrice.value = productData.old_price;
            variantVendorCode.value = productData.vendor_code;
            reviews.value = productData.reviews || [];

            nextTick(() => {
                isOpen.value = Array(computedAccordionData.value.length).fill(false);
            });

            // Обрабатываем наборы или варианты
            if (productData.is_set === 1) {
                initializeSetPriceStack();
            } else {
                // Если это не набор, проверяем vendorCodeParam
                // vendorCodeParam.value берется из route.params при инициализации
                if (vendorCodeParam.value) {
                    selectVariantByVendorCode(vendorCodeParam.value);
                } else {
                    // Если vendor_code в URL нет, выбираем первые доступные опции
                    selectFirstAvailableOptions();
                }
            }

            // Код, который должен выполняться на клиенте после загрузки и выбора варианта
            if (process.client) {
                nextTick(() => {
                    Fancybox.bind("[data-fancybox='gallery']", {
                        infinite: true,
                        buttons: ["zoom", "close"],
                    });

                    fbProduct(); // Отправляем ViewContent после выбора варианта

                    // Обновляем GTM с актуальным вариантом и ценой
                    const gtmVariantCode = selectedVariant.value?.vendor_code || productData.vendor_code;
                    // Используем актуальную цену варианта, если она есть, иначе цену продукта
                    const gtmPrice = parseFloat(variantPrice.value) || parseFloat(productData.price) || 0;

                    if (proxy?.dataLayer) {
                        proxy.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object
                        proxy.dataLayer.push({
                            event: "view_item",
                            ecommerce: {
                                currency: "UAH",
                                value: gtmPrice,
                                items: [
                                    {
                                        item_id: productData.vendor_code, // Основной ID товара
                                        item_name: productData.name,
                                        item_brand: "Le-Perle",
                                        item_category: productData.category ? productData.category.title : "",
                                        item_variant: gtmVariantCode, // Код конкретного варианта
                                        price: gtmPrice, // Цена варианта
                                        quantity: 1,
                                    },
                                ],
                            },
                        });
                    }

                    // Обновляем историю просмотренных товаров
                    let storedProducts = JSON.parse(localStorage.getItem("viewedProducts") || "[]");
                    storedProducts = storedProducts.filter((p) => p.id !== productData.id);
                    storedProducts.unshift(productData);
                    if (storedProducts.length > 10) {
                        storedProducts.pop();
                    }
                    localStorage.setItem("viewedProducts", JSON.stringify(storedProducts));
                    viewedProducts.value = storedProducts;

                    // ESputnik ProductPage tracking
                    if (productData && productData.vendor_code) {
                        trackProductPage({
                            productKey: productData.vendor_code || String(productData.id),
                            price: variantPrice.value || productData.price,
                            isInStock: productData.in_stock || 0,
                        });
                    }

                    // Прокрутка вверх
                    window.scrollTo({ top: 0, behavior: "smooth" });
                });
            }
        } else if (error.value) {
            console.error("Error loading product data:", error.value);
        }
    },
    { immediate: true }, // immediate: true важен для выполнения при первой загрузке данных
);

onMounted(() => {
    if (process.client) {
        // Инициализируем ESputnik
        initESputnik();

        viewedProducts.value = JSON.parse(localStorage.getItem("viewedProducts") || "[]");

        // GTM select_item event
        // Ensure proxy exists before trying to access dataLayer
        if (data.value?.product && proxy && proxy.dataLayer) {
            const productData = data.value.product;
            // Ensure variantPrice is somewhat initialized, even if defaults
            const initialPrice = parseFloat(variantPrice.value) || parseFloat(productData.price) || 0;

            proxy.dataLayer.push({ ecommerce: null });
            proxy.dataLayer.push({
                event: "select_item",
                ecommerce: {
                    items: [
                        {
                            item_id: productData.vendor_code,
                            item_name: productData.name,
                            item_brand: "Le-Perle",
                            item_category: productData.category ? productData.category.title : "",
                            price: initialPrice, // Use initialized price
                            quantity: 1,
                        },
                    ],
                },
            });
        }
    }
});

onUnmounted(() => {
    if (process.client) {
        Fancybox.destroy();
    }
});

watch(
    () => route.params.slug,
    (newSlug, oldSlug) => {
        // Этот watch перезапускает useAsyncData при смене slug
        if (newSlug && newSlug !== oldSlug) {
            slug.value = newSlug;
            // Обновляем vendorCodeParam, если он есть в новом URL
            vendorCodeParam.value = route.params.vendor_code;
            // Сбрасываем состояние выбора варианта
            selectedSize.value = null;
            selectedLength.value = null;
            selectedClasp.value = null;
            selectedColor.value = null;
            selectedVariant.value = null;
            // Сбрасываем стек цен для наборов
            if (priceStack && Object.keys(priceStack).length > 0) {
                Object.keys(priceStack).forEach((key) => delete priceStack[key]);
            }
            // useAsyncData перезагрузит данные, и watch(data, ...) обработает новый vendorCodeParam
        }
    },
);

useSeoMeta({
    title: data.value?.product?.name || "Завантаження...",
    description: data.value?.product?.description || `Купити ${data.value?.product?.name} в інтернет-магазині Le'Perle.`,
    ogTitle: data.value?.product?.name || "Завантаження...",
    ogDescription: data.value?.product?.description || `Купити ${data.value?.product?.name} в інтернет-магазині Le'Perle.`,
    ogImage: data.value?.product?.downloads?.[0]?.path ? `${uploadUrl}${data.value.product.downloads[0].path}` : `${config.public.siteUrl}/assets/img/logo.svg`,
    ogUrl: `${config.public.siteUrl}${route.fullPath}`,
});

// useSchemaOrg([
//     {
//         "@type": "Product",
//         name: data.value?.product?.name || "",
//         description: data.value?.product?.description || "",
//         sku: data.value?.product?.vendor_code || "",
//         mpn: data.value?.product?.vendor_code || "",
//         brand: {
//             "@type": "Brand",
//             name: "Le'Perle",
//         },
//         image: data.value?.product?.downloads?.map((download) => getImageProduct(download.path)) || [],
//         offers: {
//             "@type": "Offer",
//             url: `${config.public.siteUrl}${route.fullPath}`,
//             priceCurrency: "UAH",
//             // price: variantPrice.value,
//             // priceValidUntil: "2025-12-31",
//             itemCondition: "https://schema.org/NewCondition",
//             availability: data.value?.product?.in_stock === 1 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
//         },
//     },
// ]);
</script>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
    opacity: 0;
    height: 0;
}

.accordion-item {
    border-bottom: 1px solid #000;
    padding: 20px 10px;
}
.accordion-item:first-child {
    border-top: 1px solid #000;
}
.accordion-item button {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.accordion-item ._icon-close {
    transform: rotate(45deg);
}
.accordion-item > div {
    margin-top: 10px;
}

.content-product__engraving .vs__dropdown-toggle {
    padding: 10px 21px;
    font-size: 16px;
    max-width: 375px;
    border-radius: 6px !important;
    border-color: #000000a6;

    @media (max-width: 768px) {
        padding: 5px 15px;
    }
}

.content-product__engraving .v-select {
    max-width: 375px !important;
}
.vs__selected {
    margin-top: 0 !important;
}

.product__main-label {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 8px;
    background-color: #e74c3c;
    color: #fff;
    font-weight: 600;
    z-index: 1;
}
</style>
